import { combineReducers } from 'redux';
import recipients from './recipients';
import mailbox from './mailbox';
import threads from './threads';
import diffusion from './diffusion';

export const messagingReducer = combineReducers({
  recipients,
  mailbox,
  threads,
  diffusion,
});



// WEBPACK FOOTER //
// ./src/modules/messaging/reducers/index.js